export default __webpack_public_path__ + "static/media/apple_stimuli_fr.eaae3d16.mp4";